<template>
  <div class="pop-panel-container">
    <div class="title" v-if="this.name">{{this.name}}</div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      name: String
    },
    name: "pop-panel"
  }
</script>

<style lang="scss" scoped>
.pop-panel-container {
  padding: 40px 0;
  .title {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    vertical-align: middle;
    line-height: 1;
    margin-bottom: 40px;
    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 14px;
      background: #1DA2F0;
      vertical-align: bottom;
      margin-right: 6px;
    }
  }
}
</style>
